import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import Home from '../views/Home.vue'

Vue.use(Router)
Vue.use(Meta)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/tests',
    name: 'TestsHome',
    component: () => import('../views/Tests.vue'),
    children:[
      {
        path: "/",
        redirect: '/tests/soil'
      },
      {
        path: "/tests/:categorySlug",
        name: "Tests",
        component: () => import("../views/TestsCat.vue"), 
        props: true,
        children:[
          {
            path: "/tests/:categorySlug/:articleSlug",
            name: "Test",
            component: () => import("../views/TestsItem.vue"), 
            props: true
          }
        ]
      }
    ]
  },
  {
    path: '/carbon',
    name: 'Carbon',
    component: () => import('../views/Carbon.vue'),
    props: true
  },
  {
    path: '/faq',
    name: 'Faq',
    component: () => import('../views/Faq.vue'),
    props: true
  },
  {
    path: '/faq/:categorySlug',
    name: 'FaqCategory',
    component: () => import('../views/Faq.vue'),
    props: true
  },
  {
    path: '/faq/:categorySlug/:articleSlug',
    name: 'FaqArticle',
    component: () => import('../views/Faq.vue'),
    props: true
  },
  {
    path: '/our-lab',
    name: 'OurLab',
    component: () => import('../views/OurLab.vue')
  },
  {
    path: '/about',
    redirect: '/our-lab'
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: "/contact-us",
    redirect: '/contact'
  },
  {
    path: "/estimates",
    redirect: '/estimates/review'
  },
  {
    path: '/estimates/review',
    name: 'Review',
    component: () => import('../views/Review.vue')
  },
  {
    path: '/estimates/next-steps',
    name: 'NextSteps',
    component: () => import('../views/NextSteps.vue')
  },
  {
    path: "/estimates/download",
    redirect: '/estimates/download/estimates'
  },
  {
    path: '/estimates/download/:articleSlug',
    name: 'Download',
    component: () => import('../views/Download.vue'),
    props: true
  },
  {
    path: '/search',
    name: 'searchResults',
    component: () => import('../views/Search.vue')
  },
  {
    path: '/sitemap',
    name: 'Sitemap',
    component: () => import('../views/Sitemap.vue')
  },
  {
    path: '/terms-and-conditions',
    name: 'Terms',
    component: () => import('../views/Terms.vue')
  }
]

const router = new Router({
  mode: 'history',
  routes
})

export default router
